( function() {
    "use strict";

    angular
        .module('ccsTrApp')
        .service('ContractMinDTOCustomService', ContractMinDTOCustomService);

    ContractMinDTOCustomService.$inject = [ '$http', '$q' ];

    function ContractMinDTOCustomService( $http, $q ) {
        var service = {

        }

        return service;

    }
})();
